import React from "react";
import { IconLifebuoy, IconRefresh } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import styles from "./CategoryPicker.module.css";

export type MedicineCategory = "SCHEDULED" | "SOS";

export interface CategoryPickerProps {
  value: MedicineCategory;
  onChange: (value: MedicineCategory) => void;
}

const CategoryPicker: React.FC<CategoryPickerProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.row}>
      <button
        type="button"
        className={`${styles.card} ${
          value === "SCHEDULED" ? styles.selected : ""
        }`}
        onClick={() => onChange("SCHEDULED")}
      >
        <span className={styles.iconBox}>
          <IconRefresh size={24} stroke={1.5} />
        </span>
        <span className={styles.textCol}>
          <span className={styles.title}>
            {t("pillbox.addMedicine.scheduled")}
          </span>
          <span className={styles.subtitle}>
            {t("pillbox.addMedicine.regular")}
          </span>
        </span>
      </button>
      <button
        type="button"
        className={`${styles.card} ${value === "SOS" ? styles.selected : ""}`}
        onClick={() => onChange("SOS")}
      >
        <span className={styles.iconBox}>
          <IconLifebuoy size={24} stroke={1.5} />
        </span>
        <span className={styles.textCol}>
          <span className={styles.title}>{t("pillbox.sos")}</span>
          <span className={styles.subtitle}>
            {t("pillbox.addMedicine.asNeeded")}
          </span>
        </span>
      </button>
    </div>
  );
};

export default CategoryPicker;
